<template>
    <div class="budget-schedule campaign-step">
        <div class="step-header">
            <div class="step-icon">
                <img src="/images/calendar-coin.svg" alt="budget and schedule" />
            </div>
            <h2>{{ $t('messages.budget_schedule') }}</h2>
        </div>

        <div class="settings-content">
            <!-- Валюта -->
            <Currency :currency="localData.currency" :currencies="currencies" :locked="lockCurrency"
                @update="updateCurrency" />

            <!-- Расписание показа -->
            <SchedulePeriods
                :initial-schedules="(serverCampaign && serverCampaign.schedules) ? JSON.parse(JSON.stringify(serverCampaign.schedules)) : (campaign?.schedule || localData.schedule || [])"
                :campaign-id="serverCampaign?.id || campaign?.id || null" :currency="localData.currency"
                :currencies="currencies" :is-test="isTest" @update="updateScheduleData" />

            <!-- Распределение показов -->
            <DayDistribution :value="localData.lifeTimeDistribution" :title="$t('messages.life_time_distribution')"
                :options="lifeTimeOptions" @update="updateLifeTimeDistribution" />

            <!-- (Time of day and day distribution removed) -->
        </div>
    </div>
</template>

<script>
import Currency from './BudgetSchedule/Currency.vue';
import SchedulePeriods from './BudgetSchedule/SchedulePeriods.vue';
import DayDistribution from './BudgetSchedule/DayDistribution.vue';

export default {
    name: "BudgetSchedule",
    components: {
        Currency,
        SchedulePeriods,
        DayDistribution
    },
    props: {
        campaign: {
            type: Object,
            default: () => ({})
        },
        // original campaign from server (relation data) when editing
        serverCampaign: {
            type: Object,
            default: () => null
        },
        currencies: {
            type: Array,
            default: () => []
        }
        ,
        lockCurrency: {
            type: Boolean,
            default: false
        }
        ,
        isEditMode: {
            type: Boolean,
            default: false
        },
        isTest: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localData: {
                currency: (this.currencies && this.currencies.length) ? this.currencies[0].currency : 'USD',
                totalBudget: 0.00,
                schedule: [{
                    startDate: this.getTodayDate(),
                    startTime: '00:00',
                    endDate: this.getTodayDate(),
                    endTime: '23:59',
                    budget: 0.00
                }],
                lifeTimeDistribution: 'evenly'
            },
            lifeTimeOptions: [
                { value: 'evenly', label: this.$t('messages.evenly') },
                { value: 'fast', label: this.$t('messages.fast') }
            ],
            // dayOptions removed
        };
    },
    mounted() {
        this.initializeData();
    },
    beforeUnmount() {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }
    },
    watch: {
        campaign: {
            handler(newCampaign) {
                if (newCampaign) {
                    this.initializeData();
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        initializeData() {
            if (this.campaign) {
                // Initialize simple fields from campaign; schedule periods are provided
                // directly to SchedulePeriods via the `schedules` prop.
                if (this.campaign.currency) {
                    this.localData.currency = typeof this.campaign.currency === 'object' ? (this.campaign.currency.currency || this.localData.currency) : this.campaign.currency;
                } else if (this.campaign.currency_code) {
                    this.localData.currency = this.campaign.currency_code;
                }

                if (this.campaign.total_budget !== undefined) {
                    this.localData.totalBudget = this.campaign.total_budget;
                } else if (this.campaign.totalBudget !== undefined) {
                    this.localData.totalBudget = this.campaign.totalBudget;
                }

                this.localData.lifeTimeDistribution = this.campaign.lifetime_distribution ?? this.campaign.lifeTimeDistribution ?? this.localData.lifeTimeDistribution;
            }
        },
        mapScheduleData(schedules) {
            if (!schedules || schedules.length === 0) {
                return [{
                    startDate: this.getTodayDate(),
                    startTime: '00:00',
                    endDate: this.getTodayDate(),
                    endTime: '23:59',
                    budget: 0.00
                }];
            }

            return schedules.map(schedule => ({
                startDate: schedule.start_date ? schedule.start_date.split('T')[0] : this.getTodayDate(),
                startTime: schedule.start_time || '00:00',
                endDate: schedule.end_date ? schedule.end_date.split('T')[0] : this.getTodayDate(),
                endTime: schedule.end_time || '23:59',
                budget: schedule.budget != null ? parseFloat(schedule.budget) : 0
            }));
        },

        getTodayDate() {
            return new Date().toISOString().split('T')[0];
        },
        updateCurrency(currency) {
            this.localData.currency = currency;
            this.updateData();
        },

        // budgetData handling removed — total budget is computed from schedule periods

        updateScheduleData(scheduleData) {
            this.localData.schedule = scheduleData.schedule || scheduleData;
            this.updateData();
        },

        updateLifeTimeDistribution(distribution) {
            this.localData.lifeTimeDistribution = distribution;
            this.updateData();
        },

        // time/day-distribution handlers removed

        updateData() {
            // Простая реализация debounce
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
            }
            this.updateTimeout = setTimeout(() => {
                this.$emit('update', this.localData);
            }, 100);
        }
    }
};
</script>

<style lang="scss" scoped>
.budget-schedule {
    max-width: 800px;
}

::deep(.toggle-buttons) {
    display: flex;
    gap: 0;
    background: rgba(245, 245, 245, 1);
    border-radius: 2px;
    padding: 2px;
    border: 0;

    :deep(.toggle-btn) {
        padding: 8px 16px;
        border-radius: 2px;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 14px;

        &:hover {
            background: rgb(245 245 245);
        }

        &.active {
            background: white;
            color: black;
        }
    }
}
</style>
